import React, { Fragment, useState } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import errorIcon from "../../assets/img/ci_warning.png";

const TimeSheetDate = ({
  label,
  showError,
  handleDateChange,
  selectedDate,
  handleDisableDate,
}) => {
  return (
    <Fragment>
      <div className="email-text sf-font">
        {label}
        <div className="email-mandatory">(Mandatory)</div>
      </div>
      <div>
        <DatePicker
          placeholder="MM DD,YYYY"
          className={`datePicker ${showError ? "error-block" : ""}`}
          format="MMMM DD, YYYY"
          value={selectedDate || null}
          disabledDate={handleDisableDate}
          onChange={handleDateChange}
          allowClear={false}
        />
      </div>
      {showError && (
        <div className="error-msg-content">
          <img src={errorIcon} alt="Error icon" />
          <span className="error-text">
            Please enter your start date to continue
          </span>
        </div>
      )}
    </Fragment>
  );
};

export default TimeSheetDate;
